<template>
    <div v-loading="loadingTemplate">
        <!-- Add message template to {{ customerName }}<br> -->
        <el-row :gutter="10" class="mb-20">
            <el-card class="pb-20">
                <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" fadeInRight>
                    <el-select
                        filterable
                        v-model="selectedPhoneNumber" @change="filterNumberChange" placeholder="Select number">
                        <el-option
                            v-for="(data, key) in number" :key="key"
                            :label="data"
                            :value="data">
                        </el-option>
                    </el-select>&nbsp;
                    <!-- <el-button @click="dialogShowCust=true" type="primary" size="mini">Add Template</el-button> -->
                </el-col>
                <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" fadeInRight>
                        <el-select
                            filterable
                            v-model="selectedHsm" placeholder="Select hsm template" :loading="loadingListHsm">
                            <el-option
                                v-for="(template, key) in hsmList" :key="key"
                                :label="template.name"
                                :value="template._id"
                                :disabled="hsmAssigned(template._id) ? true : false">
                            </el-option>
                        </el-select>&nbsp;
                        <el-button type="primary" @click="userHsmAssigned" :loading="loadingAddTemplate">Assign</el-button>
                        <!-- <el-button type="danger" @click="userHsmUnassigned" :loading="loadingUnassignedTemplate">Unassign</el-button> -->
                </el-col>
            </el-card>
        </el-row>
        <el-alert title="Info" type="info" :closable="false" description="No Data" show-icon v-if="userDetail.hsm.length == 0"></el-alert>
        <div v-else>
            <el-card>
                <el-button type="primary" class="mb-20" size="" @click="downloadTemplate">
                    <i class="mdi mdi-download"/> Download
                </el-button>
                <!-- <br> -->
                <el-table :data="userDetail.hsm" style="width: 100%">
                    <!-- <el-table-column type="expand">
                        <template slot-scope="props">
                            <p>Name: {{ props.row.name }}</p>
                            <p>Body Message: {{ props.row.message }}</p>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="name" label="Template Name" width="300" fixed="left">
                        <template slot-scope="props">
                            <p style="font-weight:bold;">{{ props.row.name }}</p>
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="category" label="Template Category" width="300" fixed="left">
                        <template slot-scope="props">
                            <p style="font-weight:bold;">{{ props.row.category }}</p>
                        </template>
                    </el-table-column>

                    <el-table-column prop="language" label="Language" width="100">
                        <template slot-scope="props">
                            <p style="font-weight:bold;" v-if="props.row.language == null">-</p>
                            <p style="font-weight:bold;" v-else>{{ props.row.language.toUpperCase() }}</p>
                        </template>
                    </el-table-column>

                    <el-table-column prop="productName" label="Text Message Template" width="480">
                        <template slot-scope="props">
                            <el-tooltip>
                                <div class="tooltip" slot="content">{{props.row.message}}</div>
                                <p style="font-weight:bold;">{{ props.row.message.substring(0, 50) }}...</p>
                            </el-tooltip>
                        </template>
                    </el-table-column>

                    <el-table-column prop="options" label="#" width="175" fixed="right">
                        <template slot-scope="props">
                            <el-button type="default" @click="detailTemplate(props.row)" size="mini"><i class="mdi mdi-eye" /> </el-button>
                            <el-tooltip placement="top" :open-delay="2000">
                                <div slot="content">Unassign this template</div>
                                <el-button size="mini" type="danger" @click="userHsmUnassigned(props.row._id)"><i class="mdi mdi-delete" /></el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>

                    <!-- <el-table-column fixed="right" label="#" width="120">
                        <template>
                            <el-button type="danger" icon="el-icon-delete" @click="userHsmUnassigned" size="small">
                            </el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
                <!-- <br> -->
                
            <!-- </template> -->
            </el-card>

            <el-dialog title="Template Detail" :visible.sync="dialogDetail" width="50%">
                <el-form status-icon ref="ruleForm" label-width="120px" class="demo-ruleForm">
                    <el-form-item label="Name">
                        <el-input type="text" readonly v-model="selectedTemplate.name" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="Language">
                        <template slot-scope="props">
                            <el-input type="text" readonly v-if="selectedTemplate.language" v-model="selectedTemplate.language" autocomplete="off"></el-input>
                            <el-input type="text" readonly v-else value="-" autocomplete="off"></el-input>
                        </template>
                    </el-form-item>
                    <el-form-item label="Header">
                        <template slot-scope="props">
                            <div v-if="selectedTemplate.header">
                                <el-input readonly type="text" v-model="selectedTemplate.header.type" autocomplete="off"></el-input>
                                <el-input readonly class="mt-10" type="text" v-model="selectedTemplate.header.format" autocomplete="off"></el-input>
                                <el-input readonly class="mt-10" v-if="selectedTemplate.header.format == 'text' || selectedTemplate.header.format == 'TEXT'" type="textarea" v-model="selectedTemplate.header.text" autocomplete="off"></el-input>
                                <el-input readonly class="mt-10" v-if="selectedTemplate.header.format == 'image'" type="textarea" v-model="selectedTemplate.header.example.header_handle[0]" autocomplete="off"></el-input>
                            </div>
                            <el-input readonly type="text" v-else value="-" autocomplete="off"></el-input>
                        </template>
                    </el-form-item>
                    <el-form-item label="Body Message">
                        <el-input readonly type="textarea" rows="10" v-model="selectedTemplate.message" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="Buttons" v-if="selectedTemplate.buttons">
                        <template slot-scope="props">
                            <div v-if="selectedTemplate.buttons" v-for="(btn, k) in selectedTemplate.buttons.buttons">
                                <el-input readonly type="text" v-model="btn.type" autocomplete="off"></el-input>
                                <el-input readonly class="mt-10 mb-10" type="text" v-model="btn.text" autocomplete="off"></el-input>
                                <el-input readonly class="mt-10 mb-10" v-if="btn.type=='url' || btn.type=='URL'" type="text" v-model="btn.url" autocomplete="off"></el-input>
                                <!-- <el-input readonly class="mt-10 mb-10" v-else type="text" v-model="btn.url" autocomplete="off"></el-input> -->
                            </div>
                            <el-input readonly type="text" v-else value="-" autocomplete="off"></el-input>
                        </template>
                    </el-form-item>
                    <el-form-item label="Footer">
                        <el-input readonly type="text" v-if="selectedTemplate.footer" v-model="selectedTemplate.footer" autocomplete="off"></el-input>
                        <el-input readonly type="text" v-else value="-" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import config from '../../config'
import api from '@/networkClient'
const moment = require('moment')
export default {
    props: {
        waUserDetail: {
            type: Object
        },
        detail:{
            type: Object,
            default: {}
        },
        datahsm: {
            type: Array
        },
        customerName: {
            type: String
        },
        loadingTemp: {
            type: Boolean,
            default: false
        },
        loadingListHsmTemp: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            userDetail: { hsm: [] },
            loadingAddTemplate: false,
            loadingUnassignedTemplate: false,
            selectedPhoneNumber: '',
            selectedHsm: '',
            selectedPhoneNumberUnassigned: '',
            selectedHsmUnassigned: '',
            loadingTemplate: this.loadingTemp,
            loadingListHsm: this.loadingListHsmTemp,
            hsmUser:[],
            number: [],
            consumen: {},
            loadingDetail: true,
            hsmList: this.datahsm,
            selectedTemplate: {},
            dialogDetail: false
        }
    },
    methods: {
        hsmAssigned(id){
            return _.find(this.userDetail.hsm, (v) => {
                return v._id == id
            })
        },
        deleteRow(index, rows) {
            rows.splice(index, 1);
        },
        formatDate(val, format){
            return moment(val).format('DD-MM-YYYY hh:mm:ss')
        },
        async getAllHSM(){
            // this.loadingTemplate = true
            this.loadingListHsm = true
			var self = this      
			await api({
				url:config.baseApi+'get_hsm',
				method:'GET'
			}).then(response => {
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
                    this.hsmList = response.data.data
				}
				// this.loadingTemplate = false
			}).catch(error => {
				// this.loadingTemplate = false
            })
            this.loadingListHsm = false
		},
        async userHsmAssigned(){
            this.loadingAddTemplate = true
            if(_.isEmpty(this.selectedPhoneNumber) || _.isEmpty(this.selectedHsm)){
				this.$message.error({
					showClose: false,
					message: 'All field is required'
				});
				return
			}
			let custId = this.$route.params.consumen
			await api({
				method:'post',
				url:config.baseApi+'userHsmAssigned/'+custId,
				data:{
					"user": this.userDetail.user._id,
					"hsm":this.selectedHsm
				}
			}).then(res => {
				// console.log('response add hsm to user',res.data)
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), "Assign template failed.", "error").then(() => {
                        this.selectedHsm = ""
                    })
				} else {
                    this.$swal(this.$t('success'), this.$t('success'), "success").then(() => {
                        this.loadWA()
                    })
                }
			}).catch(err => {
				// console.log('error',err.message)
            })
            this.selectedHsm = ""
			this.loadingAddTemplate = false
        },
        async userHsmUnassigned(selectedHsmDelete){
            // if(_.isEmpty(this.selectedPhoneNumberUnassigned) || _.isEmpty(this.selectedHsmUnassigned)){
			// 	this.$message.error({
			// 		showClose: false,
			// 		message: 'All field is required'
			// 	});
			// 	return
            // }
            let templateName = _.find(this.hsmList, hsm => { return hsm._id == selectedHsmDelete }).name
            this.$confirm(`Are you sure want to delete template <b>${templateName}</b> from this number?`, 'Confirm', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'warning',
                center: true,
                dangerouslyUseHTMLString: true,
			}).then(async () => {
                this.loadingUnassignedTemplate = true
                let custId = this.$route.params.consumen
                await api({
                    method:'post',
                    url:config.baseApi+'userHsmUnassigned/'+custId,
                    data:{
                        "user": this.userDetail.user._id,
                        "hsm": selectedHsmDelete
                    }
                }).then(res => {
                    // console.log('response add hsm to user',res.data)
                    if(res.data.ec != 200){
                        this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                    } else {
                        this.$swal(this.$t('success'), this.$t('success'), "success").then(() => {
                            this.loadWA()
                        })
                    }
                }).catch(err => {
                    // console.log('error',err.message)
                })
                this.loadingUnassignedTemplate = false
            }).catch(cancel => {  
            })
        },
        downloadTemplate() {
            api({
				url: 'userHsmDownload/' + this.$route.params.consumen,
				method:'POST',
                data: {
                    number: this.selectedPhoneNumber
                },
                responseType: 'blob'
			})
                .then(res => {
                    const url = window.URL.createObjectURL(res.data);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Templates.xlsx');
                    link.click();
                }).catch(() => {
                    this.showAlertError = true
                })
        },
        clear(){
			this.selectedPhoneNumber = ''
            this.selectedHsm = ''
            this.selectedPhoneNumberUnassigned = ''
			this.selectedHsmUnassigned = ''
        },
        async loadWA() {
            this.loadingTemplate = true
			let custId = this.$route.params.consumen
			await api({
				method: 'post',
                url: config.baseApi +'user/'+custId+'/detail_one',
                data: {
                    number: this.selectedPhoneNumber
                }
			}).then(result => {
                this.hsmUser = result.data.data
                // console.log(this.hsmUser)
                this.userDetail = { detail: [], hsm: [], sender: [] }
				if(result.data.ec == 200){
                    this.userDetail = result.data.data
                    this.userDetail.hsm = _.remove(result.data.data.hsm, (v) => { return _.isEmpty(v) == false })
                    // console.log("USER DETAIL",this.userDetail)
                    // this.userDetail.sender = _.uniq(tempSender)
                    // this.sender = this.userDetail.sender[0]
				} else if(result.data.ec == 400 && result.data.message == "not_subscribe"){
					this.showAlertMessage = true
				} else {
					this.showAlertError = true
				}
			}).catch(error => {
				this.showAlertError = true
            })
            this.loadingTemplate = false
        },
        async filterNumberChange(){
            this.loadWA()
        },
        detailTemplate(k){
            console.log("Data selected",k)
            this.dialogDetail = true
            this.selectedTemplate = k
        }
    },
    created() {
        if (this.selectedPhoneNumber) {
            this.loadWA()
        }
    },
    watch: {
        loadingTemp: function(){
            // console.log("loading watch", this.detail)
            this.loadingTemplate = this.loadingTemp
            if(this.loadingTemp == false){
                this.userDetail = this.detail
                this.number = this.waUserDetail.sender
                this.selectedPhoneNumber = this.number[0]
                this.hsmList = this.datahsm
            }
        },
        loadingListHsmTemp: function(){
            this.loadingListHsm = this.loadingListHsmTemp
            if(this.loadingListHsm == false){
                this.hsmList = this.datahsm
            }
        }
    }
}
</script>

<style>
.fl-r{
    float: right;
}
.tooltip{
    font-size: 14px;
    width: 200px;
}
</style>
